import React, { useState, useRef } from 'react';
import '../styles/contact.css';
import emailjs from '@emailjs/browser';
import { useTranslation } from 'react-i18next'; // Import useTranslation

function Contact() {
  const { t } = useTranslation(); // Initialize useTranslation

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_ydiiafb', 'template_8x8sc8r', form.current, {
        publicKey: 'jfbF6V-BbAOILe_lf',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          alert(t('form_submitted_success')); // Use translation key
          setFormData({
            firstName: '',
            lastName: '',
            email: '',
            subject: '',
            message: '',
          });
        },
        (error) => {
          console.log('FAILED...', error.text);
          alert(t('form_submission_failed')); // Use translation key
        },
      );
  };

  return (
    <div>
      <div className='bg' style={{
        // backgroundImage: `url(${spice2})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
      }}>
        <div className="contact-container">
          <h1>{t('contact_page_title')}</h1> {/* Use translation key */}

          <form onSubmit={sendEmail} ref={form} className="contact-form">
            <label>{t('name')} <span className="required">{t('required')}</span></label>
            <div className="name-fields">
              <div>
                <input
                  type="text"
                  name="firstName"
                  placeholder={t('first_name')}
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <input
                  type="text"
                  name="lastName"
                  placeholder={t('last_name')}
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <label>{t('email')} <span className="required">{t('required')}</span></label>
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label>{t('subject')} <span className="required">{t('required')}</span></label>
            <input
              type="text"
              name="subject"
              placeholder={t('enter_subject')}
              value={formData.subject}
              onChange={handleChange}
              required
            />

            <label>{t('message')} <span className="required">{t('required')}</span></label>
            <textarea
              name="message"
              rows="6"
              placeholder={t('your_message_here')}
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>

            <button type="submit">{t('send_message')}</button>
          </form>
        </div>
      </div>
      <div className='footer'>
        <p className='foot-head'>{t('company_name_full')}</p>
        <p>No: 37/953, 24th Main, JP Nagar II Phase, Bangalore-560078</p>
        <p>{t('all_rights_reserved', { year: new Date().getFullYear() })}</p>
      </div>
    </div>
  );
}

export default Contact;